// extracted by mini-css-extract-plugin
export default {"contact":"styles_contact__pwFd7","links":"styles_links__FntHw","left":"styles_left__625GN","right":"styles_right__zNk-E"};